export const ERROR_CONTENT = {
  notFound: {
    code: '404',
    title: "Oops! We've Lost This Friend",
    description: "The page you're looking for has wandered off.",
    button: 'Back to Home',
  },
  generic: {
    title: 'Something went wrong',
    description: 'We apologize. Please try again later.',
    button: 'Try Again',
  },
  boundary: {
    title: 'Oops! Something went wrong.',
    description:
      "We encountered an unexpected error. Our team has been notified and we're working on fixing it.",
    button: 'Back to Home',
  },
} as const;
